"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gatherAllEvents = exports.findEventsByFirstTopic = exports.findEventsByIdentifier = exports.findEventsByPredicate = exports.SmartContractCallOutcome = exports.TransactionOutcome = exports.SmartContractResult = exports.TransactionLogs = exports.TransactionEvent = void 0;
class TransactionEvent {
    constructor(init) {
        this.address = "";
        this.identifier = "";
        this.topics = [];
        this.dataItems = [];
        Object.assign(this, init);
    }
}
exports.TransactionEvent = TransactionEvent;
class TransactionLogs {
    constructor(init) {
        this.address = "";
        this.events = [];
        Object.assign(this, init);
    }
}
exports.TransactionLogs = TransactionLogs;
class SmartContractResult {
    constructor(init) {
        this.sender = "";
        this.receiver = "";
        this.data = new Uint8Array();
        this.logs = new TransactionLogs({});
        Object.assign(this, init);
    }
}
exports.SmartContractResult = SmartContractResult;
class TransactionOutcome {
    constructor(init) {
        this.directSmartContractCallOutcome = new SmartContractCallOutcome({});
        this.smartContractResults = [];
        this.logs = new TransactionLogs({});
        Object.assign(this, init);
    }
}
exports.TransactionOutcome = TransactionOutcome;
class SmartContractCallOutcome {
    constructor(init) {
        this.function = "";
        this.returnDataParts = [];
        this.returnMessage = "";
        this.returnCode = "";
        Object.assign(this, init);
    }
}
exports.SmartContractCallOutcome = SmartContractCallOutcome;
function findEventsByPredicate(transactionOutcome, predicate) {
    return gatherAllEvents(transactionOutcome).filter(predicate);
}
exports.findEventsByPredicate = findEventsByPredicate;
function findEventsByIdentifier(transactionOutcome, identifier) {
    return findEventsByPredicate(transactionOutcome, (event) => event.identifier == identifier);
}
exports.findEventsByIdentifier = findEventsByIdentifier;
function findEventsByFirstTopic(transactionOutcome, topic) {
    return findEventsByPredicate(transactionOutcome, (event) => event.topics[0]?.toString() == topic);
}
exports.findEventsByFirstTopic = findEventsByFirstTopic;
function gatherAllEvents(transactionOutcome) {
    const allEvents = [];
    allEvents.push(...transactionOutcome.logs.events);
    for (const item of transactionOutcome.smartContractResults) {
        allEvents.push(...item.logs.events);
    }
    return allEvents;
}
exports.gatherAllEvents = gatherAllEvents;
//# sourceMappingURL=resources.js.map